import { useState } from 'react'
import { InlineWidget } from 'react-calendly'
import bookContent from '@content/bookcall.yaml'
import type { BookCallContent } from '@/types/content'

const content = bookContent as unknown as BookCallContent

export function BookCall() {
  const calendlyUrl = import.meta.env.VITE_CALENDLY_URL || ''
  const formAction = import.meta.env.VITE_FORMSPREE_URL || ''
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.currentTarget
    if (formAction) {
      await fetch(formAction, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
    } else {
      // Fallback: mailto
      const data = new FormData(form)
      window.location.href = `mailto:hello@banoffee.work?subject=Enquiry from ${data.get('name')}&body=${data.get('message')}`
    }
    setSubmitted(true)
  }

  return (
    <section id="book" className="book-section">
      <div className="book-inner">
        <div className="reveal">
          <div className="ey">{content.eyebrow}</div>
          <h2 className="sh2" dangerouslySetInnerHTML={{ __html: content.headline }} />
          <p className="slead">{content.lead}</p>
          <div className="call-details">
            {content.details.map(d => (
              <div key={d.text} className="cd">
                <div className="cd-icon">{d.icon}</div>{d.text}
              </div>
            ))}
          </div>
        </div>
        <div className="cal-embed reveal d2">
          {calendlyUrl ? (
            <InlineWidget url={calendlyUrl} styles={{ height: '660px', width: '100%' }} />
          ) : (
            <>
              <div className="cal-placeholder">
                <div className="cal-ph-icon">{content.placeholder.icon}</div>
                <div className="cal-ph-title">{content.placeholder.title}</div>
                <p className="cal-ph-body">{content.placeholder.body}</p>
                <a href={content.placeholder.link.href} className="cal-ph-link">{content.placeholder.link.label}</a>
              </div>

              {/* Contact form — only shown when Calendly is not configured */}
              <div className="contact-form-wrap">
                <p className="cf-title">{content.contactForm.title}</p>
                {submitted ? (
                  <p className="cf-success">{content.contactForm.success}</p>
                ) : (
                  <form className="cf-form" onSubmit={handleSubmit}>
                    <label className="cf-label">
                      Name
                      <input type="text" name="name" placeholder={content.contactForm.namePlaceholder} required className="cf-input" />
                    </label>
                    <label className="cf-label">
                      Email
                      <input type="email" name="email" placeholder={content.contactForm.emailPlaceholder} required className="cf-input" />
                    </label>
                    <label className="cf-label">
                      Message
                      <textarea name="message" placeholder={content.contactForm.messagePlaceholder} rows={3} className="cf-input cf-textarea" />
                    </label>
                    <button type="submit" className="cf-btn">{content.contactForm.button}</button>
                  </form>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  )
}
